"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.Form = void 0;
var i18n_1 = __importDefault(require("@app/lang/i18n"));
var mask_1 = __importDefault(require("@app/lib/mask"));
var request_1 = require("@app/lib/request");
var Validation = __importStar(require("@app/lib/validation"));
var util_1 = require("@app/lib/util");
var Form = /** @class */ (function () {
    function Form(_a) {
        var _b = _a.selector, selector = _b === void 0 ? '#form' : _b, url = _a.url, successUrl = _a.successUrl, successCrezuLeadUrl = _a.successCrezuLeadUrl, country = _a.country, _c = _a.lang, lang = _c === void 0 ? 'ua' : _c, _d = _a.mask, mask = _d === void 0 ? '+{38}(000)000-00-00' : _d, _e = _a.task, task = _e === void 0 ? [] : _e, loan = _a.loan, onSubmitSuccess = _a.onSubmitSuccess, onPost = _a.onPost, _f = _a.waitPageTimeout, waitPageTimeout = _f === void 0 ? 1000 : _f;
        var _g, _h;
        this.selector = selector;
        this.url = url;
        this.successUrl = successUrl;
        this.successCrezuLeadUrl = successCrezuLeadUrl;
        this.mask = mask;
        this.task = task;
        this.loan = {
            days: parseInt((_g = loan === null || loan === void 0 ? void 0 : loan.days) !== null && _g !== void 0 ? _g : '0', 10),
            amount: parseInt((_h = loan === null || loan === void 0 ? void 0 : loan.amount) !== null && _h !== void 0 ? _h : '0', 10)
        };
        this.onSubmitSuccess = onSubmitSuccess;
        this.onPost = onPost;
        this.waitPageTimeout = waitPageTimeout;
        this.i18nMessages = i18n_1.default[lang];
        this.lang = lang;
        this.country = country !== null && country !== void 0 ? country : lang.toUpperCase();
        if (!successUrl || !url) {
            document.querySelector('#form').innerHTML = '<h1>Error: Need to define successUrl and url</h1>';
            // alert('Need to define successUrl and url');
        }
    }
    Form.prototype.showValidationErrors = function (response) {
        var _a;
        return __awaiter(this, void 0, void 0, function () {
            var validationError, message, _i, message_1, item, match, property;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0: return [4 /*yield*/, response.json()];
                    case 1:
                        validationError = _b.sent();
                        message = validationError === null || validationError === void 0 ? void 0 : validationError.message;
                        if (message) {
                            for (_i = 0, message_1 = message; _i < message_1.length; _i++) {
                                item = message_1[_i];
                                match = item.match(/^[\w.]+/);
                                if (match) {
                                    property = match[0];
                                    switch (property) {
                                        case 'email':
                                            Validation.showError('email', this.i18nMessages.validationErrorEmail);
                                            break;
                                        case 'phone':
                                            Validation.showError('phone', this.i18nMessages.validationErrorPhone);
                                            break;
                                        default:
                                            console.error(property);
                                    }
                                }
                                else {
                                    console.log("No match found.");
                                }
                            }
                        }
                        if (((_a = validationError === null || validationError === void 0 ? void 0 : validationError.errors) === null || _a === void 0 ? void 0 : _a.email) === false) {
                            Validation.showError('email', this.i18nMessages.validationErrorEmail);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    Form.prototype.replacePlaceholders = function (url, shortId) {
        var _a;
        var utm = __assign(__assign({}, this.utm), { shortId: shortId, webid: (_a = this.utm) === null || _a === void 0 ? void 0 : _a.content });
        return url.replace(/\[(\w+)\]/g, function (match, key) { return utm[key] || ''; });
    };
    Form.prototype.waitRedirect = function () {
        return __awaiter(this, void 0, void 0, function () {
            var formContainer;
            var _this = this;
            return __generator(this, function (_a) {
                formContainer = document.querySelector(this.selector);
                formContainer.innerHTML = "<p class=\"waitMessage\">".concat(this.i18nMessages.waitPageText, "</p>");
                return [2 /*return*/, new Promise(function (resolve) {
                        setTimeout(resolve, _this.waitPageTimeout); //A 1-second pause by default, adjustable through form parameters.
                    })];
            });
        });
    };
    Form.prototype.getRedirectUrl = function (response) {
        var _a, _b, _c, _d;
        var crezuLeadId = (_b = (_a = response === null || response === void 0 ? void 0 : response.options) === null || _a === void 0 ? void 0 : _a.task) === null || _b === void 0 ? void 0 : _b.leadId;
        if (crezuLeadId) {
            return this.successCrezuLeadUrl.replace('{lead_id}', crezuLeadId);
        }
        var redirectUrl = (_d = (_c = response === null || response === void 0 ? void 0 : response.options) === null || _c === void 0 ? void 0 : _c.task) === null || _d === void 0 ? void 0 : _d.url;
        if (redirectUrl) {
            return this.replacePlaceholders(redirectUrl, response.shortId);
            ;
        }
        return this.replacePlaceholders(this.successUrl, response.shortId);
    };
    Form.prototype.handleFormSubmit = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var request, contactDto, response, shortId, response_1, _a;
            return __generator(this, function (_b) {
                switch (_b.label) {
                    case 0:
                        request = new request_1.Request();
                        request.country = this.country;
                        contactDto = data;
                        _b.label = 1;
                    case 1:
                        _b.trys.push([1, 5, , 10]);
                        Validation.clearErrors();
                        return [4 /*yield*/, request.addContact(this.url, __assign({ ga: this.ga4, utm: this.utm, task: this.task, loan: this.loan }, contactDto))];
                    case 2:
                        response = _b.sent();
                        if (!(typeof this.onSubmitSuccess === 'function')) return [3 /*break*/, 4];
                        this.onSubmitSuccess();
                        return [4 /*yield*/, this.waitRedirect()];
                    case 3:
                        _b.sent();
                        _b.label = 4;
                    case 4:
                        shortId = response.shortId;
                        (0, util_1.setCookie)('shortId', shortId);
                        document.location = this.getRedirectUrl(response);
                        return [3 /*break*/, 10];
                    case 5:
                        response_1 = _b.sent();
                        _a = response_1.status;
                        switch (_a) {
                            case 400: return [3 /*break*/, 6];
                        }
                        return [3 /*break*/, 8];
                    case 6: return [4 /*yield*/, this.showValidationErrors(response_1)];
                    case 7:
                        _b.sent();
                        return [3 /*break*/, 9];
                    case 8:
                        console.error(response_1);
                        alert('Internal Server Error, try again later');
                        _b.label = 9;
                    case 9: return [3 /*break*/, 10];
                    case 10: return [2 /*return*/];
                }
            });
        });
    };
    Form.prototype.drawForm = function () {
        var _this = this;
        var formSubmit = function (e) {
            e.preventDefault();
            var formData = new FormData(e.target);
            var data = Object.fromEntries(formData);
            _this.handleFormSubmit(data);
        };
        try {
            var form = document.querySelector("".concat(this.selector, " form"));
            form.onsubmit = formSubmit;
            (0, mask_1.default)({
                selector: 'phone',
                mask: this.mask
            }, 'bdate');
        }
        catch (err) {
            console.error('draw error');
            console.error(err);
        }
    };
    Form.prototype.setGa4 = function (ga4) {
        this.ga4 = ga4;
    };
    Form.prototype.setUtm = function (utm) {
        this.utm = utm;
    };
    Form.prototype.render = function () {
        this.drawForm();
    };
    Form.prototype.setData = function (data) {
        var form = document.querySelector("".concat(this.selector, " form"));
        Object.entries(data).forEach(function (_a) {
            var key = _a[0], value = _a[1];
            var inputElement = form.elements[key];
            if (inputElement) {
                inputElement.value = value;
            }
        });
    };
    return Form;
}());
exports.Form = Form;
